"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeAnimationWrapperStyling = function (_a) {
    var _b = _a.effect, effect = _b === void 0 ? 'fadeIn' : _b, _c = _a.delay, delay = _c === void 0 ? 1200 : _c, _d = _a.animationTime, animationTime = _d === void 0 ? 400 : _d;
    switch (effect) {
        case 'fadeIn':
            return (0, react_1.css)({
                opacity: 0,
                animation: "fadeIn ".concat(animationTime, "ms ease-in-out ").concat(delay, "ms forwards"),
                '@keyframes fadeIn': {
                    from: {
                        opacity: 0,
                    },
                    to: {
                        opacity: 1,
                    },
                },
            });
        case 'fadeInUp':
            return (0, react_1.css)({
                opacity: 0,
                transform: 'translateY(20px)',
                animation: "fadeInUp ".concat(animationTime, "ms ease-in-out ").concat(delay, "ms forwards"),
                '@keyframes fadeInUp': {
                    from: {
                        opacity: 0,
                        transform: 'translateY(20px)',
                    },
                    to: {
                        opacity: 1,
                        transform: 'translateY(0)',
                    },
                },
            });
        case 'fadeInDown':
            return (0, react_1.css)({
                opacity: 0,
                transform: 'translateY(-20px)',
                animation: "fadeInDown ".concat(animationTime, "ms ease-in-out ").concat(delay, "ms forwards"),
                '@keyframes fadeInDown': {
                    from: {
                        opacity: 0,
                        transform: 'translateY(-20px)',
                    },
                    to: {
                        opacity: 1,
                        transform: 'translateY(0)',
                    },
                },
            });
        case 'fadeInLeft':
            return (0, react_1.css)({
                opacity: 0,
                transform: 'translateX(-20px)',
                animation: "fadeInLeft ".concat(animationTime, "ms ease-in-out ").concat(delay, "ms forwards"),
                '@keyframes fadeInLeft': {
                    from: {
                        opacity: 0,
                        transform: 'translateX(-20px)',
                    },
                    to: {
                        opacity: 1,
                        transform: 'translateX(0)',
                    },
                },
            });
        case 'fadeInRight':
            return (0, react_1.css)({
                opacity: 0,
                transform: 'translateX(20px)',
                animation: "fadeInRight ".concat(animationTime, "ms ease-in-out ").concat(delay, "ms forwards"),
                '@keyframes fadeInRight': {
                    from: {
                        opacity: 0,
                        transform: 'translateX(20px)',
                    },
                    to: {
                        opacity: 1,
                        transform: 'translateX(0)',
                    },
                },
            });
        case 'fadeInRight':
            return (0, react_1.css)({
                opacity: 0,
                transform: 'translateX(20px)',
                animation: "fadeInRight ".concat(animationTime, "ms ease-in-out ").concat(delay, "ms forwards"),
                '@keyframes fadeInRight': {
                    from: {
                        opacity: 0,
                        transform: 'translateX(20px)',
                    },
                    to: {
                        opacity: 1,
                        transform: 'translateX(0)',
                    },
                },
            });
        default:
            return (0, react_1.css)({
                opacity: 0,
                animation: "fadeIn ".concat(animationTime, "ms ease-in-out ").concat(delay, "ms forwards"),
                '@keyframes fadeIn': {
                    from: {
                        opacity: 0,
                    },
                    to: {
                        opacity: 1,
                    },
                },
            });
    }
};
exports.default = makeAnimationWrapperStyling;
//# sourceMappingURL=makeAnimationWrapperStyling.js.map